export interface SocialAccessRouter {
  goToList(query?: string): void;
  goToCreate(scope?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAccessRouter = Symbol('SocialRolesRouter');
